import ConnectWithoutContactIcon from '@mui/icons-material/ConnectWithoutContact';

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const referralDetails = {
    id: 'referralDetails',
    // title: 'Dashboard',
    type: 'group',
    children: [
        {
            id: 'referralDetails',
            title: 'Referral Details',
            type: 'item',
            url: '/referralDetails',
            icon: ConnectWithoutContactIcon,
            breadcrumbs: false,
            
        }
    ]
};

export default referralDetails;
